import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Radio,
  Pagination,
  Modal,
  ThemeProvider,
  createTheme,
  IconButton,
  CircularProgress,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
  },
});

const TestRailTemplatesComponentPage = ({
  selectedProject,
  templates,
  setTemplates,
  templatesLoading,
  selectedTemplate,
  setSelectedTemplate,
  setOpenTemplatePage,
  setOpenSuitePage,
  setSelectedProject,
  setALMModalOpen,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const templatesPerPage = 6;

  const filteredTemplates = (templates || []).filter((template) =>
    template.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedTemplates = filteredTemplates.slice(
    (page - 1) * templatesPerPage,
    page * templatesPerPage
  );

  const handleBack = () => {
    setOpenTemplatePage(false); // Back to project selection
    setSelectedProject(null);
    setTemplates([]);
    setSelectedTemplate(null); // ✅ This is what clears the template
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setOpenTemplatePage(false); // Close this modal
    setOpenSuitePage(true); // Open suite selection
  };
  const handleCloseModal = () => {
    setOpenTemplatePage(false);
    setALMModalOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={true} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            height: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            display: "flex",
            flexDirection: "column",
            outline: "none",
          }}
        >
          {/* <IconButton
            size="small"
            sx={{ color: "black", "& svg": { fontSize: "0.9rem" } }}
            onClick={handleBack}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <IconButton
            onClick={() => setOpenTemplatePage(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" sx={{ mb: 2 }}>
            Select Test Case Template from {selectedProject?.name}
          </Typography> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ArrowBackIosNewIcon
                fontSize="small"
                onClick={handleBack}
                sx={{ mr: 1, cursor: "pointer" }}
              />
              <Typography sx={{ fontSize: "17px" }}>
                Select Test Case Template from {selectedProject?.name}
              </Typography>
            </Box>

            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Typography variant="subtitle2" color="text.secondary">
              Choose a template to continue
            </Typography>
            <TextField
              size="small"
              placeholder="Search templates"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              sx={{ width: 200 }}
            />
          </Box>

          {templatesLoading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : filteredTemplates.length === 0 ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography>No templates found</Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 1.5,
                  flex: 1,
                  overflowY: "auto",
                }}
              >
                {displayedTemplates.map((template) => (
                  <Card
                    key={template.id}
                    variant="outlined"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: 90,
                      p: 1,
                      borderRadius: 2,
                      cursor: "pointer",
                    }}
                    onClick={() => handleTemplateSelect(template)}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", ml: -1 }}>
                      <Radio
                        checked={selectedTemplate?.id === template.id}
                        value={template.id}
                        onChange={() => handleTemplateSelect(template)}
                      />
                      <Typography variant="body2" fontWeight="bold">
                        {template.name}
                      </Typography>
                    </Box>
                  </Card>
                ))}
              </Box>

              <Pagination
                count={Math.ceil(filteredTemplates.length / templatesPerPage)}
                page={page}
                onChange={(e, val) => setPage(val)}
                sx={{ mt: 2, display: "flex", justifyContent: "center" }}
              />
            </>
          )}
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default TestRailTemplatesComponentPage;
